export default __webpack_public_path__ + "static/thumbnail-9f822f2d6a903fcd4693ab8a9a2ebf10.png";